/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostMemoryCommentImagesSignedurlRequestFileInfosInner
 */
export interface PostMemoryCommentImagesSignedurlRequestFileInfosInner {
    /**
     * 
     * @type {string}
     * @memberof PostMemoryCommentImagesSignedurlRequestFileInfosInner
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof PostMemoryCommentImagesSignedurlRequestFileInfosInner
     */
    fileExtension: string;
    /**
     * 
     * @type {string}
     * @memberof PostMemoryCommentImagesSignedurlRequestFileInfosInner
     */
    contentType: string;
}

/**
 * Check if a given object implements the PostMemoryCommentImagesSignedurlRequestFileInfosInner interface.
 */
export function instanceOfPostMemoryCommentImagesSignedurlRequestFileInfosInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fileName" in value;
    isInstance = isInstance && "fileExtension" in value;
    isInstance = isInstance && "contentType" in value;

    return isInstance;
}

export function PostMemoryCommentImagesSignedurlRequestFileInfosInnerFromJSON(json: any): PostMemoryCommentImagesSignedurlRequestFileInfosInner {
    return PostMemoryCommentImagesSignedurlRequestFileInfosInnerFromJSONTyped(json, false);
}

export function PostMemoryCommentImagesSignedurlRequestFileInfosInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostMemoryCommentImagesSignedurlRequestFileInfosInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileName': json['fileName'],
        'fileExtension': json['fileExtension'],
        'contentType': json['contentType'],
    };
}

export function PostMemoryCommentImagesSignedurlRequestFileInfosInnerToJSON(value?: PostMemoryCommentImagesSignedurlRequestFileInfosInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileName': value.fileName,
        'fileExtension': value.fileExtension,
        'contentType': value.contentType,
    };
}

